export const LoginTokenAuth = {
    HeaderName: "Authentication",
    GetHeaderValue: () => {
        const authValue = localStorage.getItem(LoginTokenAuth.HeaderName);
        return (`token ${authValue}`);
    },

    DeleteAccessToken: () => {
        localStorage.removeItem(LoginTokenAuth.HeaderName);
    }
};
